<div class="topbar clearfix">
  <organisation-selector></organisation-selector>
  <add-number-to-organisation></add-number-to-organisation>
  <div
    class="topbar-left"
    [style.background-color]="isProduction ? '#f7f7f7' : isBeta ? '#F8BC3B' : '#C90057'"
    [style.background-image]="
      isSaasUser
        ? 'url(https://s3.eu-west-2.amazonaws.com/bucket.engineius.portal-static-content/engynn/engynn_full.svg)'
        : null
    "
  >
    <div class="logo"></div>
    <div class="env-identifier mt-1" *ngIf="!isProduction && !isBeta">
      <span>Test Environment</span>
    </div>
    <div class="beta-env-identifier mt-1" *ngIf="isBeta">
      <span>Beta Environment</span>
    </div>
  </div>

  <div class="topbar-right">
    <app-telephony-control></app-telephony-control>
    <div *ngIf="isSuspended">
      <div class="suspended-info">
        <app-account-suspended></app-account-suspended>
      </div>
    </div>
    <a id="menu-button" href="#" (click)="app.onMenuButtonClick($event)">
      <i></i>
    </a>

    <a id="topbar-menu-button" href="#" (click)="app.onTopbarMenuButtonClick($event)">
      <i class="material-icons">menu</i>
    </a>
    <ul
      class="topbar-items animated fadeInDown"
      [ngClass]="{ 'topbar-items-visible': app.topbarMenuActive }"
    >
      <li
        #profile
        class="profile-item"
        [ngClass]="{ 'active-top-menu': app.activeTopbarItem === profile }"
      >
        <a href="#" (click)="app.onTopbarItemClick($event, profile)">
          <i class="topbar-icon material-icons">person</i>
          <span
            *ngIf="isVmeUser"
            class="topbar-badge animated rubberBand"
            pTooltip="Number of Incidents assigned to Me"
            >{{ myIncidentsTotal }}</span
          >
        </a>

        <ul class="ultima-menu animated fadeInDown">
          <li *ngIf="isVmeUser && !restrictedUser" role="menuitem">
            <a (click)="myIncidents($event)">
              <i class="material-icons" style="color: #ff8f00">report_problem</i>
              <span>My Incidents</span>
            </a>
          </li>
          <li role="menuitem">
            <a (click)="openProfile($event)">
              <i class="material-icons">person</i>
              <span>Profile</span>
            </a>
          </li>
          <li role="menuitem">
            <a (click)="logout($event)" href="#">
              <i class="material-icons">power_settings_new</i>
              <span>Logout</span>
            </a>
          </li>
          <li role="menuitem" [hidden]="!isUserImpersonate">
            <a href="#" (click)="stopImpersonate($event)">
              <i class="material-icons">power_settings_new</i>
              <span>End Impersonate</span>
            </a>
          </li>
        </ul>
      </li>

      <li
        *ngIf="isVmeUser && !restrictedUser"
        #notifications
        [ngClass]="{ 'active-top-menu': app.activeTopbarItem === notifications }"
      >
        <a href="#" (click)="app.onTopbarItemClick($event, notifications); openIncidents()">
          <i class="topbar-icon material-icons" pTooltip="Go to Incidents Screen">notifications</i>
          <span
            class="topbar-badge animated rubberBand"
            pTooltip="Number of Unassigned Incidents"
            >{{ incidentsTotal }}</span
          >
          <span class="topbar-item-name">Incidents</span>
        </a>
      </li>

      <li
        *ngIf="!restrictedUser"
        #search
        class="search-item"
        [ngClass]="{ 'active-top-menu': app.activeTopbarItem === search }"
        (click)="app.onTopbarItemClick($event, search)"
      >
        <form (ngSubmit)="showSearchChoices($event)">
          <span class="md-inputfield">
            <input
              type="text"
              style="text-transform: uppercase"
              name="searchVal"
              id="searchVal"
              pInputText
              (click)="searchChoices = false"
              tooltipStyleClass="xtooltip"
              tooltipPosition="bottom"
              [escape]="false"
              pTooltip="
                               <div style='padding: 0 5px;'>To search using only part of an order/job/transaction number use the * symbol</div>
                               <div style='padding: 0 5px 10px 5px;'>Example: To search for a job containing 53CE enter: *5C3E*</div>"
              [(ngModel)]="searchModel.value"
              style="color: #0081cb"
            />
            <label style="color: #0081cb">Search</label>
            <span [hidden]="showSpinner">
              <a (click)="showSearchChoices($event)">
                <i class="topbar-icon material-icons">search</i>
              </a>
            </span>
            <span [hidden]="!showSpinner"
              ><span class="search-spinner"
                ><img src="assets/images/loader.gif" alt="Loading" width="35" height="35" /></span
            ></span>
          </span>
        </form>
        <div *ngIf="searchChoices" class="searchChoices">
          <div style="padding-bottom: 5px">Searching for:</div>
          <div class="searchItem">
            <p-radioButton
              name="forOrder"
              id="forOrder"
              label="Order"
              value="order"
              [(ngModel)]="searchModel.searchType"
              (ngModelChange)="searchJobs(searchModel)"
            ></p-radioButton>
          </div>

          <div class="searchItem">
            <p-radioButton
              name="forJob"
              id="forJob"
              label="Job"
              value="job"
              [(ngModel)]="searchModel.searchType"
              (ngModelChange)="searchJobs(searchModel)"
            ></p-radioButton>
          </div>
          <div class="searchItem">
            <p-radioButton
              name="forVehicle"
              id="forVehicle"
              label="Vehicle"
              value="vehicle"
              [(ngModel)]="searchModel.searchType"
              (ngModelChange)="searchJobs(searchModel)"
            ></p-radioButton>
          </div>
          <div class="searchItem">
            <p-radioButton
              name="forPostcode"
              id="forPostcode"
              label="Postcode"
              value="postcode"
              [(ngModel)]="searchModel.searchType"
              (ngModelChange)="searchJobs(searchModel)"
            ></p-radioButton>
          </div>
          <div class="searchItem">
            <p-radioButton
              name="forDate"
              id="forDate"
              label="Date"
              value="date"
              [(ngModel)]="searchModel.searchType"
              (ngModelChange)="searchJobs(searchModel)"
            ></p-radioButton>
          </div>
          <div class="searchItem">
            <p-radioButton
              name="forVIN"
              id="forVIN"
              label="VIN"
              value="VIN"
              [(ngModel)]="searchModel.searchType"
              (ngModelChange)="searchJobs(searchModel)"
            ></p-radioButton>
          </div>
          <div class="searchItem" *ngIf="isVmeUser">
            <p-radioButton
              name="forTransaction"
              id="forTransaction"
              label="Transaction"
              value="Transaction"
              [(ngModel)]="searchModel.searchType"
              (ngModelChange)="searchTransactions(searchModel)"
            ></p-radioButton>
          </div>
        </div>
      </li>

      <li *ngIf="isVmeUser || isUserImpersonate">
        <div
          pTooltip="Search organisation information"
          tooltipPosition="left"
          *ngIf="!loadingSupplierInfo"
          (click)="openOrgSelector()"
          class="phone-icon"
        >
          <i class="fa fa-phone"></i>
          <div style="font-size: 14px">{{ telephonyExt || 'Info' }}</div>
        </div>
        <div *ngIf="loadingSupplierInfo" (click)="openOrgSelector()" style="text-align: right">
          <i
            class="fa fa-2x fa-spinner fa-spin spinner"
            pTooltip="Loading Supplier Info.."
            tooltipPosition="left"
          ></i>
        </div>
      </li>

      <li id="impersonation_banner" *ngIf="isUserImpersonate">
        <div class="md-inputfield">
          <span>Impersonation Mode: {{ impersonatedUserName }}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
